import { render, staticRenderFns } from "./ShowShapes.vue?vue&type=template&id=e8709ee6&scoped=true"
import script from "./ShowShapes.vue?vue&type=script&lang=js"
export * from "./ShowShapes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8709ee6",
  null
  
)

export default component.exports